import Model from '@/models/Model.js';

export default class CourseEnrollmentEnrollmentGroup extends Model {
    static entity = 'course_enrollment_enrollment_group';

    static primaryKey = ['course_enrollment_id', 'enrollment_group_id'];

    static fields() {
        return {
            id: this.attr(null),
            course_id: this.attr(null),
            course_enrollment_id: this.attr(null),
            enrollment_group_id: this.attr(null),

            ...super.fields(),

            course: this.belongsTo('courses', 'course_id'),
            course_enrollment: this.belongsTo('course_enrollments', 'course_enrollment_id'),
            enrollment_group: this.belongsTo('enrollment_groups', 'enrollment_group_id'),
        };
    }
}
